import BaseReportTableModel from '../common/base-report-table-model'
import DatasetReportDataExtractor from './dataset-report-data-extractor'

const DatasetReportTableModel = BaseReportTableModel.extend({

	dataExtractor: function(model) {
		return new DatasetReportDataExtractor(model)
	}

})

export default DatasetReportTableModel
DatasetReportTableModel.__filename__ = 'reports/dataset-report/dataset-report-table-model.js'
